import React, { Suspense } from "react";
import useCommonHooks from "./hooks/useCommonHooks";
import { useAppSelector } from "./store/index.ts";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setModalFortune } from "./store/siteSlice";
import Head from "./Head.jsx";
import FortuneModal from "./components/modal/fortune_modal/FortuneModal.jsx";
import ShowContainer from "./components/mui/ShowContainer.jsx";
import { ENUM_HASH, TEST_MODE } from "./store/enums";
import LiveChat from "./components/LiveChat.jsx";
import Toaster from "./components/mui/Toaster.jsx";

export default function NavigateOnLoad() {
  useCommonHooks();
  const logoUrl = useAppSelector((state) => state.common.logoUrl);
  const openFortune = useAppSelector((state) => state.site.modals.fortune);
  const { hash } = useLocation();
  const dispatch = useDispatch();

  const closeFortune = () => dispatch(setModalFortune(false));
  const shouldMountFortune =
    openFortune || hash === ENUM_HASH.fortune || hash === ENUM_HASH.fortune_on;

  return (
    <>
      <Head favicon={logoUrl} appleTouchIcon={logoUrl} />
      {shouldMountFortune && (
        <Suspense fallback={null}>
          <FortuneModal isOpen={!!openFortune} closeModal={closeFortune} />
        </Suspense>
      )}
      <ShowContainer condition={!TEST_MODE}>
        <LiveChat />
      </ShowContainer>

      <Toaster />
    </>
  );
}
